import { addCommas, removeCommas } from "@persian-tools/persian-tools";

import { CustomInput } from "../../kits/Inputs/Inputs";

export default function ServiceProductDetail({
  changeFirstTabData,
  data,
  addOrEdit,
}) {
  console.log("FirstTabData object", data);
  return (
    <div className="d-flex align-items-center final-product-detail">
      <div className="col-6 col-md-3 px-1">
        <CustomInput
          label="قیمت پایه"
          inputSize="lg"
          type="text"
          inputContainer=""
          inputClassName=""
          activate={addOrEdit == "edit" ? "disabled" : ""}
          inputValue={addCommas(data.price)}
          onChangeFunc={(e) => {
            if (!isNaN(removeCommas(e.target.value)))
              changeFirstTabData(removeCommas(e.target.value), "price");
          }}
          // textErr={validationTxt.answers}
        />
      </div>
    </div>
  );
}
